import { Order } from './Order';
export var Attr;
(function (Attr) {
    let Source;
    (function (Source) {
        Source["Calc"] = "CALC";
        Source["Column"] = "COLUMN";
        Source["Field"] = "FIELD";
        Source["Param"] = "PARAM";
        Source["Names"] = "NAMES";
        Source["Values"] = "VALUES";
    })(Source = Attr.Source || (Attr.Source = {}));
    let Role;
    (function (Role) {
        Role["Dimension"] = "DIMENSION";
        Role["Measure"] = "MEASURE";
    })(Role = Attr.Role || (Attr.Role = {}));
    let Type;
    (function (Type) {
        Type["Continuous"] = "CONTINUOUS";
        Type["Discrete"] = "DISCRETE";
    })(Type = Attr.Type || (Attr.Type = {}));
    let Scale;
    (function (Scale) {
        Scale["Categorical"] = "CATEGORICAL";
        Scale["Ordinal"] = "ORDINAL";
        Scale["Quantitative"] = "QUANTITATIVE";
    })(Scale = Attr.Scale || (Attr.Scale = {}));
    function categorical(formula, name, opts = {}) {
        const role = "DIMENSION";
        const type = "DISCRETE";
        const scale = "CATEGORICAL";
        return { formula, name, role, type, scale, ...opts };
    }
    Attr.categorical = categorical;
    const DefaultOrdinalOpts = { order: Order.Sequential.make() };
    function ordinal(formula, name, type, role, opts = DefaultOrdinalOpts) {
        const scale = "ORDINAL";
        const order = opts.order || Order.Sequential.make();
        return { formula, name, role, type, scale, order, ...opts };
    }
    Attr.ordinal = ordinal;
    const DefaultQuantitativeOpts = {
        order: Order.Sequential.make(),
    };
    function quantitative(formula, name, opts = DefaultQuantitativeOpts) {
        const role = "MEASURE";
        const type = "CONTINUOUS";
        const scale = "QUANTITATIVE";
        const order = opts.order || Order.Sequential.make();
        return { formula, name, role, type, scale, order, ...opts };
    }
    Attr.quantitative = quantitative;
    function dimension(source, type, role) {
        return { source, type, role };
    }
    Attr.dimension = dimension;
    let Dimension;
    (function (Dimension) {
        function make(source, type, role) {
            return Attr.dimension(source, type, role);
        }
        Dimension.make = make;
    })(Dimension = Attr.Dimension || (Attr.Dimension = {}));
    function measure(source, type, role) {
        return { source, type, role };
    }
    Attr.measure = measure;
    let Measure;
    (function (Measure) {
        function make(source, type, role) {
            return Attr.measure(source, type, role);
        }
        Measure.make = make;
    })(Measure = Attr.Measure || (Attr.Measure = {}));
})(Attr || (Attr = {}));
